import {
  // baseApi,
  baseOmegaApi,
  // SESSION_TAG,
  type OmegaApiResponse,
} from '@shared/api';
import {
  type RedeemChallengeData,
  type RedeemChallengeParams,
} from '../model';

export type RedeemChallengeResponse = Partial<OmegaApiResponse> & {
  data?: RedeemChallengeData;
};

// export type ChallengesResponse = Partial<OmegaApiResponse> & {
//   data?: RedeemChallengeData;
// };

// //TODO: Will be moved later to challenges page
// export const getChallengesApiSlicer = baseApi.injectEndpoints({
//   endpoints: (build) => ({
//     getChallenges: build.query<ChallengesResponse, void>({
//       query: () => ({ url: '/api/ips/get-challenges' }),
//       providesTags: [SESSION_TAG],
//       extraOptions: { showLoader: false, auth: true },
//     }),
//   }),
// });

export const redeemChallengesApiSlicer = baseOmegaApi.injectEndpoints({
  endpoints: (build) => ({
    redeemChallenge: build.query<RedeemChallengeResponse, RedeemChallengeParams>({
      query: (params: RedeemChallengeParams) => ({ url: '/ips/challenge/redeem', params }),
      extraOptions: { auth: true, showLoader: true },
    }),
  }),
});

export const {
  useLazyRedeemChallengeQuery,
} = redeemChallengesApiSlicer;

// export const {
//   useGetChallengesQuery
// } = getChallengesApiSlicer;
